export default {
  blocks: [
    {
      key: '8gng3',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'fg6de',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 0,
        },
      ],
      data: {},
    },
    {
      key: '2tgn2',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'lmu9',
      text: ' ',
      type: 'atomic',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [
        {
          offset: 0,
          length: 1,
          key: 1,
        },
      ],
      data: {},
    },
    {
      key: 'eig9s',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
  entityMap: {
    '0': {
      type: 'wix-draft-plugin-image',
      mutability: 'IMMUTABLE',
      data: {
        config: {
          alignment: 'center',
          size: 'content',
          showTitle: true,
          showDescription: true,
        },
        src: {
          id: '8a719c372d21ebb4b9d2a8373734bf52',
          original_file_name: '8bb438_209feb1fb8944a18b6b619e105746cd0.jpg',
          file_name: '8bb438_209feb1fb8944a18b6b619e105746cd0.jpg',
          width: 1621,
          height: 1081,
        },
      },
    },
    '1': {
      type: 'wix-draft-plugin-gallery',
      mutability: 'IMMUTABLE',
      data: {
        config: {
          alignment: 'center',
          size: 'content',
          layout: 'small',
          spacing: 0,
        },
        items: [
          {
            metadata: {
              type: 'image',
              height: 3066,
              width: 4600,
            },
            itemId: '7a5e2e30ec277ada8e1715ed520e6b38',
            url: '8bb438_4fe0d8e3dee641559dffc604be287e32.jpg',
          },
          {
            metadata: {
              type: 'image',
              height: 5600,
              width: 3737,
            },
            itemId: '0a1f3af15dc764fd08e5c83a9febb30e',
            url: '8bb438_a59d1b89bd074b75b62a8838034f72f6.jpg',
          },
          {
            metadata: {
              type: 'image',
              height: 1700,
              width: 2557,
            },
            itemId: 'b86f277fb5fb7ba5a1e698458d4e23c7',
            url: '8bb438_9db65bcf6aef45cb8a0eb107602ef85a.jpg',
          },
        ],
        styles: {
          galleryLayout: 2,
          gallerySizeType: 'px',
          gallerySizePx: 300,
          galleryMargin: 0,
          oneRow: false,
          cubeRatio: 1,
          galleryThumbnailsAlignment: 'bottom',
          isVertical: false,
          imageMargin: 20,
          thumbnailSpacings: 0,
          cubeType: 'fill',
          enableInfiniteScroll: true,
          titlePlacement: 'SHOW_ON_HOVER',
          allowHover: true,
          itemClick: 'link',
          fullscreen: false,
          showArrows: false,
          gridStyle: 1,
          loveButton: false,
          allowSocial: false,
          allowDownload: false,
          mobileSwipeAnimation: 'NO_EFFECT',
          thumbnailSize: 120,
          gotStyleParams: true,
          showVideoPlayButton: true,
          videoPlay: 'onClick',
        },
      },
    },
  },
  VERSION: '8.27.1',
};
